import { useEffect, useMemo, useState } from "react";
import { Search } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { api } from "../lib/api";
import { OpportunityCard } from "../components/opportunities/OpportunityCard";
import { Reveal, Stagger } from "../components/Reveal";

export default function OpportunitiesPage() {
  const { t } = useLang();
  const [opps, setOpps] = useState(null);
  const [spec, setSpec] = useState("all");
  const [q, setQ] = useState("");

  useEffect(() => { api.get("/opportunities?status=open").then((r) => setOpps(r.data)).catch(() => setOpps([])); }, []);

  const specialties = useMemo(() => [...new Set((opps || []).map((o) => o.specialty_ar))], [opps]);
  const filtered = useMemo(() => (opps || []).filter((o) =>
    (spec === "all" || o.specialty_ar === spec) &&
    (!q || `${o.title_en} ${o.title_ar} ${o.specialty_ar} ${o.specialty_en}`.toLowerCase().includes(q.toLowerCase()))
  ), [opps, spec, q]);

  return (
    <main data-testid="opportunities-page">
      <div className="container">
        <Reveal className="page-head"><span className="kicker">{t.opps.kicker}</span><h1>{t.opps.pageTitle}</h1><p>{t.opps.pageSub}</p></Reveal>
        <div className="toolbar">
          <div className="chips">
            <button className={`chip ${spec === "all" ? "active" : ""}`} onClick={() => setSpec("all")} data-testid="filter-all">{t.opps.all}</button>
            {specialties.map((s) => <button key={s} className={`chip ${spec === s ? "active" : ""}`} onClick={() => setSpec(s)} data-testid={`filter-${s}`}>{s}</button>)}
          </div>
          <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
            <div className="search-box"><Search size={16} /><input value={q} onChange={(e) => setQ(e.target.value)} placeholder={t.opps.search} data-testid="opportunities-search" /></div>
          </div>
        </div>
        {opps === null ? <div className="page-loader"><span className="loader" /></div>
          : filtered.length === 0 ? <div className="empty" data-testid="opportunities-empty">{t.opps.empty}</div>
          : <Stagger className="opp-grid" stagger={0.06} key={`${spec}-${q}`}>{filtered.map((o) => <OpportunityCard opp={o} key={o.id} />)}</Stagger>}
        <div style={{ height: 96 }} />
      </div>
    </main>
  );
}
